import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import BColor from '../BColor'
import { useTheme } from '@material-ui/core/styles';

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        marginLeft: 5,
        marginRight: 5,
        paddingLeft: 5,
        paddingRight: 5
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            // backgroundColor: theme.palette.background.default,
        },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 250,
      backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
    },
    button1: {
      minWidth: 110,
    }
  }));

export default function CashReport2(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [buyselldata, setBuyselldata] = React.useState([]);


    useEffect(() => {
        if (props.open) fectchStockData(props.stockId)
    }, [props.stockId]);


    function fectchStockData(stockId) {
        if (stockId != null) {
            let a = {
                sid: stockId,
                inp: {}
            };

            fetch("/jstock/v1/stock/finreport/cashlist", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        if (result.length > 0) {
                            setBuyselldata(result)
                        }
                    },
                    error => {
                    }
                );
        }
    }


    function renderValue3(value) {
        let colorx = BColor.faircolor
        let word = "-"
        let unit = "百萬元"

        if (value === undefined || value == null || value === -99999) {
            word = "-"
            unit = ''
        } else {
            let x = 1000000
            if (value > 100000000 || value < -100000000) {
                x = 100000000
                unit = "億元"
            } else if (value > 1000000 || value < -1000000) {
                x = 1000000
            }
            word = ((value / x).toFixed(1)).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        }

        if (value < 0 && value != -99999)
            colorx = BColor.downcolorbox
        return <Button size="small" variant="outlined" style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}{unit}</Button>
    }


    function genYmdWord(row) {
        if(row.month === 3) return row.year + "第" + row.season + "季"
        else if(row.month === 12) return row.year + "年度"
        else return "-"
    }

    function getColor(row) {
        if (row.month === 12) {
            if(theme.palette.type === "light")
            return "#cccccc"
            else return "#454545"
        }
        else return null
    }

    return (
        <Dialog
            // fullWidth={true}
            // maxWidth={'lg'}
            fullScreen
            open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{props.stockName}({props.stockId})現金流量表</DialogTitle>

            <DialogContent style={{ overflow: "hidden" }}>
                <TableContainer style={{ maxHeight: '80vh' }}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>日期</StyledTableCell>
                                <StyledTableCell align="center">營業活動</StyledTableCell>
                                <StyledTableCell align="center">投資活動</StyledTableCell>
                                <StyledTableCell align="center">籌資活動</StyledTableCell>
                                <StyledTableCell align="center">資本支出</StyledTableCell>
                                <StyledTableCell align="center">自由現金流</StyledTableCell>
                                <StyledTableCell align="center">淨現金流</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd} style={{backgroundColor: getColor(row)}}>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="left">
                                        {genYmdWord(row)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                        {renderValue3(row.cffu)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue3(row.ncffi)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                        {renderValue3(row.cffuif)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                        {renderValue3(row.captialout)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                        {renderValue3(row.freecash)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                        {renderValue3(row.cceep)}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}
